import Vue from 'vue'
import VueRouter from 'vue-router'
import Store from '@/store'
import Axios from 'axios'
import Qs from 'qs'
import {
	Message,
	MessageBox
} from 'element-ui'
Vue.use(VueRouter)

const routes = [{
		path: '/', //首页
		name: 'Home',
		component: () => import('@/views/Home')
	},{
		path: '/user/:id?', //企业信息
		name: 'User',
		component: () => import('@/views/User')
	},{
		path: '/bindwx', //绑定微信
		name: 'Bindwx',
		component: () => import('@/views/Bindwx')
	},{
		path: '/renovation', //店铺装修
		name: 'renovation',
		component: () => import('@/views/renovation')
	},{
		path: '/shopTemplate', //店铺模板列表
		name: 'ShopTemplate',
		component: () => import('@/views/ShopTemplate')
	},{
		path: '/shopTemplate/:id', //店铺模板详情
		name: 'ShopTemplateId',
		component: () => import('@/views/ShopTemplate/ShopTemplateId')
	},{
		path: '/applet', //微信小程序
		name: 'Applet',
		component: () => import('@/views/Applet')
	},{
		path:'/bdxcx',//百度小程序
		name:'Bdxcx',
		component:() => import('@/views/Bdxcx')
	},{
		path: '/vip', //vip
		name: 'Vip',
		component: () => import('@/views/Vip')
	},{
		path: '/seo', //vip
		name: 'Seo',
		component: () => import('@/views/Seo')
	},{
		path: '/leaflet1', //商机订阅
		name: 'Leaflet1',
		component: () => import('@/views/Leaflet1')
	}, {
		path: '/product', //商品列表
		name: 'Product',
		component: () => import('@/views/Product'),
	}, {
		path: '/product/release', //发布商品
		name: 'ProductRelease',
		component: () => import('@/views/Product/Release')
	}, {
		path: '/product/revise', //修改商品
		name: 'ProductRevise',
		component: () => import('@/views/Product/Revise'),
		beforeEnter(to, from, next) {
			if (!to.query.id) {
				next('/404')
			} else {
				next()
			}
		}
	}, {
		path: '/product/copy', //复制商品
		name: 'ProductCopy',
		component: () => import('@/views/Product/Copy'),
		beforeEnter(to, from, next) {
			if (!to.query.id) {
				next('/404')
			} else {
				next()
			}
		}
	}, {
		path: '/setShop', //店铺设置
		name: 'SetShop',
		component: () => import('@/views/SetShop'),
		children: [{
				path: 's0',
				name: 'SetShop0',
				component: () => import('@/views/SetShop/S0')
			}, {
				path: 's1',
				name: 'SetShop1',
				component: () => import('@/views/SetShop/S1')
			}, {
				path: 's2',
				name: 'SetShop2',
				component: () => import('@/views/SetShop/S2')
			}, {
				path: 's3',
				name: 'SetShop3',
				component: () => import('@/views/SetShop/S3')
			},
			{
				path: 's4',
				name: 'SetShop4',
				component: () => import('@/views/SetShop/S4')
			},
			{
				path: 's5',
				name: 'SetShop5',
				component: () => import('@/views/SetShop/S5')
			},
			{
				path: '/setShop',
				redirect: 's0'
			}
		]
	}, {
		path: '/expo', //展会设置
		name: 'Expo',
		component: () => import('@/views/Expo'),
		children: [{
				path: 'e0',
				name: 'Expo0',
				component: () => import('@/views/Expo/e0')
			}, {
				path: 'e1',
				name: 'Expo1',
				component: () => import('@/views/Expo/e1')
			}, {
				path: 'e2',
				name: 'Expo2',
				component: () => import('@/views/Expo/e2')
			}, {
				path: 'e3',
				name: 'Expo3',
				component: () => import('@/views/Expo/e3')
			},
			{
				path: 'e4',
				name: 'Expo4',
				component: () => import('@/views/Expo/e4')
			},{
				path: 'e5',
				name: 'Expo5',
				component: () => import('@/views/Expo/e5')
			},{
				path: 'e6', //合作伙伴
				name: 'Expo6',
				component: () => import('@/views/Expo/e6')
			},
			{
				path: '/expo',
				redirect: 'e0'
			}
		]
	},{
		path: '/zhgl', //展会管理
		name: 'Zhgl',
		component: () => import('@/views/Zhgl')
	},{
		path: '/zhgl/revise', //修改展会信息
		name: 'zhglRevise',
		component: () => import('@/views/Zhgl/Revise'),
		beforeEnter(to, from, next) {
			if (!to.query.id) {
				next('/404')
			} else {
				next()
			}
		}
	},{
		
		path: '/Tutorial', //操作手册
		name: 'Tutorial',
		component: () => import('@/views/Tutorial/index')
	},
	{
		
		path: '/LeavingMessage', //留言管理
		name: 'LeavingMessage',
		component: () => import('@/views/LeavingMessage')
	},
	{
		path: '/zhgl/exhibit', //参展
		name: 'Zhglexhibit',
		component: () => import('@/views/Zhgl/exhibit')
	},
	{
		path: '/zhgl/viewing', //观展
		name: 'Zhglviewing',
		component: () => import('@/views/Zhgl/viewing')
	},{
		path: '/news', //新闻管理
		name: 'News',
		component: () => import('@/views/News')
	}, {
		path: '/news/release', //发布新闻
		name: 'NewsRelease',
		component: () => import('@/views/News/Release')
	}, {
		path: '/news/revise', //修改新闻
		name: 'NewsRevise',
		component: () => import('@/views/News/Revise'),
		beforeEnter(to, from, next) {
			if (!to.query.id) {
				next('/404')
			} else {
				next()
			}
		}
	}, {
		path: '/zhnews', //展会新闻管理
		name: 'Zhnews',
		component: () => import('@/views/Zhnews')
	}, {
		path: '/zhnews/release', //发布展会新闻
		name: 'ZhnewsRelease',
		component: () => import('@/views/Zhnews/Release')
	}, {
		path: '/zhnews/revise', //修改展会新闻
		name: 'ZhnewsRevise',
		component: () => import('@/views/Zhnews/Revise'),
		beforeEnter(to, from, next) {
			if (!to.query.id) {
				next('/404')
			} else {
				next()
			}
		}
	},{
		path: '/hyzh', //行业展会
		name: 'Hyzhnews',
		component: () => import('@/views/Hyzh')
	}, {
		path: '/hyzh/release', //发布行业展会新闻
		name: 'HyzhRelease',
		component: () => import('@/views/Hyzh/Release')
	}, {
		path: '/hyzh/revise', //修改行业展会新闻
		name: 'HyzhRevise',
		component: () => import('@/views/Hyzh/Revise'),
		beforeEnter(to, from, next) {
			if (!to.query.id) {
				next('/404')
			} else {
				next()
			}
		}
	},
	//展会参展公司
	{
		path: '/exhibitor', 
		name: 'Exhibitor',
		component: () => import('@/views/Exhibitor')
	}, {
		path: '/exhibitor/release',
		name: 'ExRelease',
		component: () => import('@/views/Exhibitor/Release')
	}, {
		path: '/exhibitor/revise', 
		name: 'ExRevise',
		component: () => import('@/views/Exhibitor/Revise'),
		beforeEnter(to, from, next) {
			if (!to.query.id) {
				next('/404')
			} else {
				next()
			}
		}
	},
	{
		path: '/wjhg', //往届回顾
		name: 'Wjhg',
		component: () => import('@/views/Wjhg')
	}, {
		path: '/wjhg/release', //发布往届回顾
		name: 'WjhgRelease',
		component: () => import('@/views/Wjhg/Release')
	}, {
		path: '/wjhg/revise', //修改往届回顾
		name: 'WjhgRevise',
		component: () => import('@/views/Wjhg/Revise'),
		beforeEnter(to, from, next) {
			if (!to.query.id) {
				next('/404')
			} else {
				next()
			}
		}
	},{
		path: '/cases', //工程示例
		name: 'Cases',
		component: () => import('@/views/Cases')
	}, {
		path: '/cases/release', //发布工程
		name: 'CasesRelease',
		component: () => import('@/views/Cases/Release')
	}, {
		path: '/cases/revise', //修改工程
		name: 'CasesRevise',
		component: () => import('@/views/Cases/Revise'),
		beforeEnter(to, from, next) {
			if (!to.query.id) {
				next('/404')
			} else {
				next()
			}
		}
	}, {
		path: '/cusCl', //自定义分类
		name: 'CusCl',
		component: () => import('@/views/CusCl')
	}, {
		path: '/order', //订单管理
		name: 'Order',
		component: () => import('@/views/Order')
	}, {
		path: '/purchase', //采购管理
		name: 'Purchase',
		component: () => import('@/views/Purchase')
	}, {
		path: '/purchase/release', //发布采购
		name: 'PurchaseRelease',
		component: () => import('@/views/Purchase/Release')
	}, {
		path: '/purchase/revise', //修改采购
		name: 'PurchaseRevise',
		component: () => import('@/views/Purchase/Revise'),
		beforeEnter(to, from, next) {
			if (!to.query.id) {
				next('/404')
			} else {
				next()
			}
		}
	}, {
		path: '/assets', //资产管理
		name: 'Assets',
		component: () => import('@/views/Assets')
	}, {
		path: '/integral', //积分
		name: 'Integral',
		component: () => import('@/views/Integral')
	}, {
		path: '/integral/recharge', //充值
		name: 'IntegralRecharge',
		component: () => import('@/views/Integral/Recharge')
	}, {
		path: '/authen', //企业认证
		name: 'Authen',
		component: () => import('@/views/Authen'),
		children: [{
			path: 's1',
			name: 'Authen1',
			component: () => import('@/views/Authen/S1')
		}, {
			path: 's2',
			name: 'Authen2',
			component: () => import('@/views/Authen/S2')
		}, {
			path: 's3',
			name: 'Authen3',
			component: () => import('@/views/Authen/S3')
		}, {
			path: '/authen',
			redirect: 's1'
		}]
	}, {
		path: '/album', //相册管理
		name: 'Album',
		component: () => import('@/views/Album')
	},{
		path: '/album/list', //相册管理
		name: 'AlbumList',
		component: () => import('@/views/Album/List'),
		beforeEnter(to, from, next) {
			if (!to.query.id) {
				next('/404')
			} else {
				next()
			}
		}
	},  {
		path: '/VideoAlbum', //相册管理
		name: 'VideoAlbum',
		component: () => import('@/views/VideoAlbum')
	},{
		path: '/VideoAlbum/list', //相册管理
		name: 'VideoAlbumList',
		component: () => import('@/views/VideoAlbum/List'),
		beforeEnter(to, from, next) {
			if (!to.query.id) {
				next('/404')
			} else {
				next()
			}
		}
	}, {
		path: '/company', //公司要闻
		name: 'Company',
		component: () => import('@/views/Company')
	},
	{
		path: '/company/release', //发布新闻
		name: 'CompanyRelease',
		component: () => import('@/views/Company/Release')
	}, {
		path: '/company/revise', //修改新闻
		name: 'CompanyRevise',
		component: () => import('@/views/Company/Revise')
	},
	{
		path: '/honor', //荣誉资质
		name: 'Honor',
		component: () => import('@/views/Honor')
	},
	{
		path: '/honor/release', //发布荣誉资质
		name: 'HonorRelease',
		component: () => import('@/views/Honor/Release')
	}, {
		path: '/honor/revise', //修改荣誉资质
		name: 'HonorRevise',
		component: () => import('@/views/Honor/Revise')
	},
	{
		path: '/newest', //最新研发
		name: 'Newest',
		component: () => import('@/views/Newest')
	}, {
		path: '/newest/release', //发布最新研发
		name: 'NewestRelease',
		component: () => import('@/views/Newest/Release')
	}, {
		path: '/newest/revise', //修改最新研发
		name: 'NewestRevise',
		component: () => import('@/views/Newest/Revise')
	}, {
		path: '/industry', //行业应用
		name: 'Industry',
		component: () => import('@/views/Industry')
	}, {
		path: '/industry/release', //发布行业应用
		name: 'IndustryRelease',
		component: () => import('@/views/Industry/Release')
	}, {
		path: '/industry/revise', //修改行业应用
		name: 'IndustryRevise',
		component: () => import('@/views/Industry/Revise')
	}, {
		path: '/recruitment', //招聘信息
		name: 'Recruitment',
		component: () => import('@/views/Recruitment')
	}, {
		path: '/recruitment/release', //发布行业应用
		name: 'RecruitmentRelease',
		component: () => import('@/views/Recruitment/Release')
	}, {
		path: '/recruitment/revise', //修改行业应用
		name: 'RecruitmentRevise',
		component: () => import('@/views/Recruitment/Revise')
	}, {
		path: '/miss', //升级高级会员
		name: 'Miss',
		component: () => import('@/views/Miss')
	}, {
		path: '/miss/sx', //升级首席会员
		name: 'sx',
		component: () => import('@/views/Miss/Sx')
	},{
		path: '/announcement', //系统公告
		name: 'Announcement',
		component: () => import('@/views/Announcement')
	},{
		path: '/announcement/read', //查看消息
		name: 'read',
		component: () => import('@/views/Announcement/read')
	},{
		path: '/announcement/open', //已读消息
		name: 'open',
		component: () => import('@/views/Announcement/open')
	},{
		path: '/announcement/noOpen', //未读消息
		name: 'noOpen',
		component: () => import('@/views/Announcement/noOpen')
	},{
		path: '/auszahlung', //申请支付
		name: 'Auszahlung',
		component: () => import('@/views/Auszahlung')
	},{
		path: '/auszahlung/trading', //申请2
		name: 'trading',
		component: () => import('@/views/Auszahlung/trading')
	},{
		path: '/auszahlung/check', //核对申请
		name: 'check',
		component: () => import('@/views/Auszahlung/check')
	},
	// {
	// 	path: '/auszahlung/audit', //审核中
	// 	name: 'audit',
	// 	component: () => import('@/views/Auszahlung/audit')
	// },
	{
		path: '/tiktok', //抖音获客
		name: 'Tiktok',
		component: () => import('@/views/Tiktok')
	},{
		path: '/tiktok/customer', //客户列表
		name: 'Tiktok',
		component: () => import('@/views/Tiktok/customer')
	},{
		path: '/tiktok/video', //视频列表
		name: 'Tiktok',
		component: () => import('@/views/Tiktok/video')
	}, {
		path: '/expert', //申请专家文库
		name: 'Expert',
		component: () => import('@/views/Expert')
	}, {
		path: '/expertList', //专家文库列表
		name: 'Expert',
		component: () => import('@/views/Expert/list')
	}, {
		path: '/expert/release', //发布专家
		name: 'ExpertRelease',
		component: () => import('@/views/Expert/Release')
	}, {
		path: '/expert/revise', //修改专家
		name: 'ExpertRevise',
		component: () => import('@/views/Expert/Revise')
	},
	{
		path: '/vote', //投票管理
		name: 'Vote',
		component: () => import('@/views/Vote')
	},
	{
		path: '/vote/release', //投票管理
		name: 'VoteRelease',
		component: () => import('@/views/Vote/Release')
	}, {
		path: '/vote/revise', //投票管理
		name: 'VoteRevise',
		component: () => import('@/views/Vote/Revise')
	},{
		path: '/vote/addXS', //投票管理
		name: 'VoteXS',
		component: () => import('@/views/Vote/addXS')
	},{
		path: '/player', //选手
		name: 'Player',
		component: () => import('@/views/Player')
	}, {
		path: '/player/release', //选手
		name: 'PlayerRelease',
		component: () => import('@/views/Player/Release')
	}, {
		path: '/player/revise', //选手
		name: 'PlayerRevise',
		component: () => import('@/views/Player/Revise'),
		beforeEnter(to, from, next) {
			if (!to.query.id) {
				next('/404')
			} else {
				next()
			}
		}
	},{
		path: '/partners', //合作伙伴
		name: 'Partners',
		component: () => import('@/views/Partners')
	}, {
		path: '/partners/release', //添加合作伙伴
		name: 'PartnersRelease',
		component: () => import('@/views/Partners/Release')
	}, {
		path: '/partners/revise', //修改合作伙伴
		name: 'PartnersRevise',
		component: () => import('@/views/Partners/Revise'),
		beforeEnter(to, from, next) {
			if (!to.query.id) {
				next('/404')
			} else {
				next()
			}
		}
	},{
		
		path: '/communication', //通讯
		name: 'Communication',
		component: () => import('@/views/Communication')
	},{
		path: '/hymember', //会员管理 会员列表
		name: 'Hymember',
		component: () => import('@/views/Hymember')
	}, {
		path: '/hynews', //会员管理 新闻列表
		name: 'Hynews',
		component: () => import('@/views/Hymember/hynews')
	}, {
		path: '/hyprocure', //会员管理 采购
		name: 'Hyprocure',
		component: () => import('@/views/Hymember/hyprocure')
	}, {
		path: '/hyproduct', //会员管理 产品
		name: 'Hyproduct',
		component: () => import('@/views/Hymember/hyproduct')
	}, {
		path: '/hyposter', //会员管理 广告位
		name: 'Hyposter',
		component: () => import('@/views/Hymember/hyposter')
	},{
		path: '/hypreferred', //会员管理 优选厂商
		name: 'Hypreferred',
		component: () => import('@/views/Hymember/preferred')
	},{
		path: '/hylinksList', //会员管理 友情链接
		name: 'HylinksList',
		component: () => import('@/views/Hymember/hylinksList')
	},{
		path: '/hyorder', //会员管理 订单列表
		name: 'Hyorder',
		component: () => import('@/views/Hymember/hyorder')
	},{
		path: '/video', //发布视频
		name: 'Video',
		component: () => import('@/views/Video')
	},{
		path: '/video/release', //发布视频
		name: 'VRelease',
		component: () => import('@/views/Video/release')
	},
	{
		path: '/expertTeam', //专家团队
		name: 'ExpertTeam',
		component: () => import('@/views/ExpertTeam')
	},
	{
		path: '/expertTeam/release', //发布专家团队
		name: 'ExTeamRelease',
		component: () => import('@/views/ExpertTeam/Release')
	}, {
		path: '/expertTeam/revise', //修改专家团队
		name: 'ExTeamRevise',
		component: () => import('@/views/ExpertTeam/Revise')
	},{
		path: '/404',
		name: '404',
		component: () => import('@/views/Error/404')
	}, {
		path: '*',
		redirect: '/404'
	}
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
	scrollBehavior(to,from,saveTop){
		
		if(saveTop){
		
		return saveTop;
		
		}else{
		
		return {x:0,y:0}
		
	} },
	routes,
	base: process.env.BASE_URL,
	
})
let remark;
 router.beforeEach((to, from, next) => {
	 
	let {
		USER_ID,
		I_SHOP
	} = Store.state
	if (USER_ID && I_SHOP) {
		judShop(I_SHOP, to, from, next)
	} else {
		Axios.post(Store.state.BASE_URL+'/Myseller-Index-getSellerInfo').then(res => {
			console.log("首",res)
			if (res.data.code == 41000) {
				location.href = Store.state.USER_URL+"Login-login.html"
			}
			const data = res.data.data
			if(data.remark != null){
				remark = data.remark
			}else{
				remark = ''
				
			}
			Store.commit('SET_I_SHOP', data.ishop)
			Store.commit('SET_HEAD_IMG', data.headimg)
			Store.commit('SET_USER_NAME', data.username)
			Store.commit("SET_I_EVEL",Number(data.level))
			Store.commit("SET_USER_ID",Number(data.userid))
			Store.commit("SET_SELLER_ID",Number(data.sellerid))
			// 设定一个值判断是店铺还是展会 默认显示店铺
			Store.commit("SET_ISZ",Number(data.is_exhibition))
			Store.commit("SET_FLAGSHIP",Number(data.flagship))
			Store.commit("SET_QJEND",data.end_time)
			Store.commit("SET_QJSTART",data.start_time)
			// Store.commit("SET_ISZ",Number(1))
			return Store.state.I_SHOP
		}).then(ishop => {
			judShop(ishop, to, from, next)
		})
	}
})

function judShop(i_shop, to, from, next) {
	i_shop *= 1
	switch (i_shop) {
		case 0:
			if (to.name.includes('Authen')) {
				next()
			} else {
				MessageBox.alert('店铺正在审核中', '提示', {
					type: 'warning'
				}).then(() => {
					location.href = Store.state.USER_URL+'/Member-index.html#/member'
					
				}).catch(() => {
					location.href = Store.state.USER_URL+'/Member-index.html#/member'
				})
			}
			break
		case 1:
			if (to.name.includes('Authen')) {
				next('/404')
			} else {
				next()
			}
			break
		case 3:
			if (to.name.includes('Authen')) {
				next()
			} else {
				MessageBox.alert('请您先填写资料申请店铺', '提示', {
					type: 'warning'
				}).then(() => {
					next('/authen')
				})
			}
			break
		case 2:
			if (to.name.includes('Authen')) {
				next()
			} else {
				if(remark != ''){
					MessageBox.alert(remark, '提示：', {
						type: 'error'
					}).then(() => {
						next("/authen")
					})
				}else{
					MessageBox.alert('您的店铺审核未通过，点击确定修改后重新提交', '提示', {
						type: 'error'
					}).then(() => {
						next('/authen')
					})
				}
			}
			break
		default:
			location.href = Store.state.USER_URL+"Login-login.html"
			break
	}
} 

export default router
